import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "SiftCascader",
  props: ["sift", "col", "label-width"],
  components: {},
  data: function data() {
    return {
      loaidng: false,
      value: []
    };
  },
  computed: {},
  created: function created() {
    var _iterator = _createForOfIteratorHelper(this.sift.selectList),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        var value = item.defaultValue ? item.defaultValue : "";
        this.value.push(value);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    changeValue: function changeValue(index) {
      var _this = this;

      if (index + 1 <= this.sift.selectList.length - 1) {
        for (var i = index + 1; i < this.sift.selectList.length; i++) {
          this.sift.selectList[i].data = [];
          this.value[i] = "";
        }

        if (this.value[index] != "") {
          this.$nextTick(function () {
            _this.fetchData(index + 1);
          });
        }
      }
    },
    fetchData: function fetchData(index) {
      var _this2 = this;

      this.loaidng = true;
      var keyName = this.sift.selectList[index - 1].key;
      var obj = {};
      obj[keyName] = this.value[index - 1];
      this.$http.post(this.sift.selectList[index].url, this.$qs.stringify(obj)).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          _this2.sift.selectList[index].data = data.resData.data;
          _this2.value[index] = data.resData.defaultValue;
        }

        _this2.loaidng = false;
      }).catch(function () {
        _this2.loaidng = false;
      });
    },
    getValue: function getValue() {
      var _this3 = this;

      var obj = {};
      this.sift.selectList.forEach(function (item, index) {
        obj[item.key] = _this3.value[index];
      });
      return obj;
    },
    resetValue: function resetValue() {
      this.value = [];
    }
  },
  watch: {},
  filters: {}
};